import React from "react";
import { Link } from "react-router-dom";

export function SectionHeading({ eyebrow, title, subtitle, align = "center", link, className = "" }) {
  const alignment = align === "left" ? "text-left items-start" : "text-center items-center";
  return (
    <div className={`flex flex-col ${alignment} ${className}`}>
      {eyebrow && (
        <span className="text-luxe text-xs font-medium text-gold mb-3" data-testid="section-eyebrow">
          {eyebrow}
        </span>
      )}
      <div className={`flex w-full ${align === "left" ? "flex-col sm:flex-row sm:items-end sm:justify-between gap-4" : "flex-col items-center"}`}>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-ink leading-[1.1]">
          {title}
        </h2>
        {link && (
          <Link
            to={link.to}
            data-testid={link.testId || "section-link"}
            className="text-luxe text-xs font-medium text-ink border-b border-ink pb-1 hover:text-gold hover:border-gold transition-colors whitespace-nowrap"
          >
            {link.label}
          </Link>
        )}
      </div>
      {subtitle && (
        <p className={`mt-4 max-w-2xl text-muted-foreground text-sm sm:text-base leading-relaxed ${align === "center" ? "mx-auto" : ""}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
